import { getFieldNameWithPrefix } from '@monorepo/shared/componentsV2/fields/fieldUtils';
import { WysiwygEditorField } from '@monorepo/shared/componentsV2/fields/WysiwygEditorField';
import { isWysiwygEditorEmpty } from '@monorepo/shared/componentsV2/WysiwgEditor';
import { isRequired } from '@monorepo/shared/utils/validators';
import React from 'react';
import styled from 'styled-components';
import { ModalFieldWrapper, ModalTextField } from '../styled';

export const ModalQuillWrapper = styled.div`
  max-width: 50rem;
  margin: 0 0 0.1rem;

  & .quill {
    display: block;
    width: 100%;

    & .ql-editor {
      min-height: 10rem;
    }
  }
`;

const hasHelpText = (value: string) =>
  isWysiwygEditorEmpty(value)
    ? 'Explanation area text cannot be empty, it is required.'
    : undefined;

// this is rendered within FinalForm so the inputs are managed by it
export function EditExplanationAreaFieldForm({ prefix }: { prefix?: string }) {
  const helpTextFieldName = getFieldNameWithPrefix('helpText', prefix);

  return (
    <>
      <ModalFieldWrapper>
        <ModalTextField
          label="Field Name"
          name={getFieldNameWithPrefix('name', prefix)}
          validate={isRequired}
          required
          tooltipText="The name of an explanation area field will not be shown to users when completing a form submission. You will only see this name when editing the form."
          dontSaveSpaceForErrorText
        />
      </ModalFieldWrapper>
      <ModalQuillWrapper>
        <WysiwygEditorField
          isRequired
          name={helpTextFieldName}
          validate={hasHelpText}
          label="Explanation Area"
          toolTipText="Saving this field may remove more complex formatting in order to make the Explanation compatible with mobile display.  If you need special web-only formatting, please contact Customer Service."
        />
      </ModalQuillWrapper>
    </>
  );
}
